import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../css_files/Master/AddSubCategoryMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";
import Select from "react-select";

function AddSubCategoryMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  subcategorypdatedata,
}) {
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState({
    Name: triggerupdate ? subcategorypdatedata?.name : "",
    Description: triggerupdate ? subcategorypdatedata?.description : "",
    CategoryId: triggerupdate ? subcategorypdatedata?.categoryId : "",
  });
  const [reloadDropdown, setreloadDropdown] = useState(false);
  const [rotatedropdownicon, setrotatedropdownicon] = useState(false);
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState(false);
  const { setExpiredSession } = useContext(triggerscroll);

  useEffect(() => {
    setrotatedropdownicon(true);

    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Category/GetCategoryDropdown`
      )
      .then((res) => {
        setCategoryData(res.data);
      })
      .catch(console.log)
      .finally(() => {
        setrotatedropdownicon(false);
      });
  }, [reloadDropdown]);

  function handleSubmit(e) {
    e.preventDefault();

    setloading(true);
    if (triggerupdate) {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/SubCategory/UpdateSubCategory`;
      axiosInstance
        .post(url, {
          id: subcategorypdatedata.id,
          name: subCategoryData.Name,
          categoryID: subCategoryData.CategoryId,
          description: subCategoryData.Description,
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((err) => {
          if (err.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: err.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(err);
          setloading(false);
        });
    } else {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/SubCategory`;
      axiosInstance
        .post(url, subCategoryData)
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          console.error("Error adding hsn data:", error);
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          setloading(false);
        });
    }
  }
  return (
    <form className="add-sub-category-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          Category Name{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <Select
            isSearchable
            options={categoryData}
            onChange={(values) => {
              if (values) {
                setSubCategoryData({
                  ...subCategoryData,
                  CategoryId: values?.value,
                });
              }
            }}
            value={categoryData?.find(
              (x) => x?.value === subCategoryData.CategoryId
            )}
            isClearable
            required
            placeholder="Select Category"
            styles={{
              container: (base) => ({
                ...base,
                width: "100%",
              }),
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
              control: (base, state) => ({
                ...base,
                borderColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
                boxShadow: "none",
              }),
              singleValue: (base) => ({
                ...base,
                color: "black",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "black",
                "&:hover": {
                  color: "black",
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "black",
              }),
              noOptionsMessage: (base) => ({
                ...base,
                color: "black",
              }),
            }}
            menuPlacement="top"
          />
          <i
            class={`fa-solid fa-rotate-right ${
              rotatedropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() => setreloadDropdown(!reloadDropdown)}
          ></i>
        </aside>
      </blockquote>
      <blockquote>
        <label>
          Sub-Category Name{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter Sub-Category Name"
          value={subCategoryData.Name}
          onChange={(e) =>
            setSubCategoryData({
              ...subCategoryData,
              Name: e.target.value,
            })
          }
          onInput={(e) => {
            e.target.value = e.target.value
              .replace(/[^a-zA-Z\s]/g, "")
              .slice(0, 100);
            axiosInstance
              .get(
                `${
                  process.env.REACT_APP_API_URL
                }/api/v1/SubCategory/CheckExistingSubCategory?CategoryId=${
                  subCategoryData.CategoryId || 0
                }&name=${e.target.value}`
              )
              .then((res) => {
                setMessage(res.data);
              })
              .catch(console.log);
          }}
          required
        ></input>
        <span style={{ color: "red" }}>
          {message && "SubCategory Already Exists In This Category"}
        </span>
      </blockquote>
      <blockquote>
        <label>Sub-Category Description</label>
        <textarea
          rows={5}
          placeholder="Enter Sub-Category Description (Upto 400 Characters)"
          value={subCategoryData.Description}
          onChange={(e) =>
            setSubCategoryData({
              ...subCategoryData,
              Description: e.target.value,
            })
          }
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 400);
          }}
        ></textarea>
      </blockquote>

      <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddSubCategoryMaster;
